import React from "react";

const Uploading = () => {
  return (
    <label className="uploading">
      <i className="fa fa-circle-o-notch fa-spin fa-3x" />
    </label>
  );
};

export default Uploading;
